<template>
  <v-row class="ma-4">
    <!-- Selector -->
    <v-col
      v-if="powerBis && powerBis.length > 1"
      class="col-3 text-center mt-6 pa-0"
    >
      <v-card outlined>
        <v-card-title>
          <v-select
            v-model="selectedPowerBi"
            :items="powerBis"
            item-text="name"
            item-value="url"
            :label="$t('powerBi.selectBi')"
            outlined
            dense
            hide-details
          />
        </v-card-title>
      </v-card>
    </v-col>

    <!-- Diagram -->
    <v-col v-if="hasPowerBis" class="col-12 text-center mt-4 pa-0">
      <v-card outlined>
        <v-card-title>
          <iframe
            class="power-bi"
            :src="getSelectedSrc"
            frameborder="0"
            allowFullScreen="true"
          />
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ExternalUrlService from '@/classes-shared/externalUrl/ExternalUrlService'

export default {
  name: 'PricingAnalytics',
  data() {
    return {
      selectedPowerBi: '',
      apiCaller: new ExternalUrlService(),
      powerBis: [],
    }
  },

  computed: {
    hasPowerBis() {
      return this.powerBis.length > 0
    },

    getSelectedSrc() {
      return this.selectedPowerBi
    },
  },

  watch: {
    selectedPowerBi() {
      this.$emit('changed', this.getSelectedSrc)
    },
  },

  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      this.powerBis = await this.apiCaller.getExternalUrlsForUserByType(
        'powerbi'
      )
      if (this.powerBis.length > 0) {
        this.selectedPowerBi = this.powerBis[0].url
      }
    },
  },
}
</script>

<style lang="scss">
.power-bi {
  width: 100%;
  height: 100vh;
}
</style>
